import { IonCol, IonGrid, IonImg, IonList, IonRow, IonText } from '@ionic/react';
import * as React from 'react';

import styles from '@/components/GOSession/ModalContent.module.css';
import { Input } from '@/components/Input';
import { CustomLoading } from '@/components/Loading';

import { mergeClassNames } from '@/utils';

type CreateSessionModalContentProps = {
  sessionData: {
    clientId: string;
    date: string;
    therapistId: string;
  };
  onInputChange: (field: string, value: string) => void;
  loading: boolean;
};

export const CreateSessionModalContent = ({ sessionData, onInputChange, loading }: CreateSessionModalContentProps) => {
  // TODO: Retrieve a list of clients and add it to the dropdown?
  return (
    <>
      <div className={styles.container}>
        {/* 🔥 Overlay that covers the form when loading */}
        {loading && (
          <div className={styles.loadingOverlay}>
            <CustomLoading message='Creating Session...' size='large' />
          </div>
        )}
        <IonGrid className={styles.wrapper}>
          <IonRow
            className='ion-align-items-center ion-justify-content-center ion-padding-vertical'
            style={{ width: '100%' }}>
            <IonCol className='ion-margin-top' size='12'>
              <IonList class={mergeClassNames(styles['no-padding'], styles.list)} mode='md'>
                <Input
                  disabled={loading}
                  label='Date'
                  labelPlacement='stacked'
                  onIonInput={(e) => onInputChange('date', e.detail.value!)}
                  placeholder={sessionData.date}
                  type='date'
                  value={sessionData.date}
                  variant='light'
                />
                <br />
                <Input
                  disabled={loading}
                  label='Client'
                  labelPlacement='stacked'
                  onIonInput={(e) => onInputChange('clientId', e.detail.value!)}
                  placeholder={sessionData.clientId}
                  type='text'
                  value={sessionData.clientId}
                  variant='light'
                />
                <br />
                <Input
                  disabled={loading}
                  label='Therapist'
                  labelPlacement='stacked'
                  onIonInput={(e) => onInputChange('therapistId', e.detail.value!)}
                  placeholder='therapistID'
                  type='text'
                  value={sessionData.therapistId}
                  variant='light'
                />
              </IonList>
            </IonCol>
          </IonRow>
        </IonGrid>
      </div>
    </>
  );
};
